module.exports = __webpack_public_path__ + "img/czpg.2d91804d.svg";